"use client"

import { useLocation, useNavigate } from "react-router-dom"
import { useContext, useState, useEffect } from "react"
import { AuthContext } from "../../context/AuthContext"
import api from "../../services/api"
import CreateLinkModal from "../links/CreateLinkModal"
import Logo from "../Layout/img/u2lr.jpeg"
import {
  FaHome,
  FaLink,
  FaChartBar,
  FaGlobe,
  FaQrcode,
  FaBullhorn,
  FaTools,
  FaKey,
  FaLayerGroup,
  FaCrown,
  FaChevronDown,
  FaCog,
  FaSignOutAlt,
  FaUserFriends,
} from "react-icons/fa"

export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user: authUser, logout } = useContext(AuthContext)

  const [user, setUser] = useState(authUser)
  const [plans, setPlans] = useState([])
  // const [currentPlan, setCurrentPlan] = useState(null)
  const [openDropdown, setOpenDropdown] = useState(null)
  const [showCreateModal, setShowCreateModal] = useState(false)

  useEffect(() => {
    api
      .get("/user/me")
      .then((res) => setUser(res.data.data))
      .catch(() => {})
  }, [])

  useEffect(() => {
    api.get("/subscription/plans").then((res) => {
      setPlans(
        Object.entries(res.data).map(([key, plan]) => ({
          key,
          ...plan,
        })),
      )
    })
  }, [])

  useEffect(() => {
    if (!user || !plans.length) return
    // setCurrentPlan(plans.find((p) => p.key === user.plan))
  }, [user, plans])

const navItems = [
  { name: "Dashboard", path: "/user-dashboard", icon: <FaHome /> },

  {
    name: "Manage Urls",
    icon: <FaLink />,
    dropdown: [
      { name: "All Links", path: "/dashboard/urls" },
      { name: "Expired Links", path: "/dashboard/urls-expiry" },
    ],
  },

  { name: "Domains", path: "/dashboard/custom-domains", icon: <FaGlobe /> },
  // { name: "Become a partner", path: "/dashboard/affiliate", icon: <FaAffiliatetheme /> },

  {
    name: "Analytics & Reports",
    icon: <FaChartBar />,
    dropdown: [
      { name: "Overall Analytics", path: "/dashboard/analytics" },
      { name: "Detailed Analytics", path: "/dashboard/details-analytics" },
      { name: "Custom Reports", path: "/dashboard/custom-report" },
    ],
  },

  {
    name: "QR Codes",
    icon: <FaQrcode />,
    dropdown: [
      { name: "Dynamic QR Codes", path: "/qrcodes/dynamic" },
      { name: "Instant QR Codes", path: "/qrcodes/instant" },
      { name: "Branding Templates", path: "/qrcodes/templates" },
    ],
  },

  {
    name: "Campaigns",
    path: "/campaigns-tags",
    icon: <FaBullhorn />,
    allowedPlans: ["premium", "dedicated"],
  },

  {
    name: "UTM Builder",
    path: "/utm-builder",
    icon: <FaTools />,
    allowedPlans: ["premium", "dedicated"],
  },

  {
    name: "API Access",
    path: "/api-keys",
    icon: <FaKey />,
    allowedPlans: ["premium", "dedicated"],
  },

  {
    name: "Bulk Shortener",
    path: "/bulk-links",
    icon: <FaLayerGroup />,
    allowedPlans: ["premium", "dedicated"],
  },
];


  if (user && ["free", "basic", "standard"].includes(user.plan)) {
    navItems.push({
      name: "Upgrade Plan",
      path: "/account/upgrade",
      icon: <FaCrown />,
      highlight: true,
    })
  }

const hasAccess = (item) => {
  if (!item.allowedPlans) return true; // Public feature
  if (!user) return false; // Not logged in
  return item.allowedPlans.includes(user.plan);
};

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name))
  }

const styles = {
    sidebar: {
      width: "240px",
      height: "100vh",
      backgroundColor: "#fff",
      borderRight: "1px solid #e2e8f0",
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: 1050,
      transition: "transform 0.3s ease",
      overflowY: "auto",
      maxHeight: "100vh",
    },
    hidden: {
      transform: "translateX(-100%)",
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 1040,
    },
    brandSection: {
      padding: "20px 20px",
      borderBottom: "1px solid #e2e8f0",
    },
    brandLink: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      textDecoration: "none",
    },
    brandIcon: {
      width: "40px",
      height: "40px",
      borderRadius: "10px",
      // backgroundColor: "#3b82f6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#ffffff",
      fontSize: "16px",
    },
    brandName: {
      fontSize: "20px",
      fontWeight: "700",
      color: "#1e293b",
      marginBottom: "2px",
    },
    brandSub: {
      fontSize: "12px",
      color: "#64748b",
      fontWeight: "500",
    },
    navSection: {
      flex: 1,
      overflowY: "auto",
      padding: "16px 12px",
    },
    navList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    navItem: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "10px 12px",
      borderRadius: "8px",
      textDecoration: "none",
      color: "#475569",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.15s ease",
      border: "1px solid transparent",
    },
    navItemHover: {
      backgroundColor: "#f1f5f9",
    },
    navItemActive: {
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      border: "1px solid #3b82f6",
    },
    navItemHighlight: {
      backgroundColor: "#fef3c7",
      color: "#b45309",
      border: "1px solid #fcd34d",
    },
    navItemLocked: {
      opacity: 0.5,
      cursor: "not-allowed",
    },
    navIcon: {
      fontSize: "16px",
      width: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    chevron: {
      fontSize: "10px",
      marginLeft: "auto",
      color: "#94a3b8",
      transition: "transform 0.2s ease",
    },
    chevronOpen: {
      transform: "rotate(180deg)",
    },
    dropdown: {
      listStyle: "none",
      padding: "4px 0 4px 32px",
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: "2px",
    },
    subItem: {
      display: "block",
      padding: "8px 12px",
      borderRadius: "6px",
      textDecoration: "none",
      color: "#64748b",
      fontSize: "13px",
      fontWeight: "500",
      transition: "all 0.15s ease",
    },
    subItemActive: {
      backgroundColor: "#3b82f6",
      color: "#ffffff",
    },
    crownBadge: {
      color: "#f59e0b",
      fontSize: "12px",
      marginLeft: "auto",
    },
    userSection: {
      borderTop: "1px solid #e2e8f0",
      padding: "16px",
    },
    userCard: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "12px",
      borderRadius: "10px",
      backgroundColor: "#f8fafc",
      border: "1px solid #e2e8f0",
      textDecoration: "none",
      cursor: "pointer",
      transition: "all 0.15s ease",
    },
    userAvatar: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      border: "2px solid #3b82f6",
      objectFit: "cover",
    },
    userName: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#1e293b",
      marginBottom: "2px",
    },
    planBadge: {
      display: "inline-block",
      padding: "2px 8px",
      borderRadius: "4px",
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      fontSize: "10px",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    dropdownMenu: {
      position: "absolute",
      bottom: "100%",
      left: 0,
      right: 0,
      backgroundColor: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "10px",
      boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
      marginBottom: "8px",
      overflow: "hidden",
      zIndex: 50,
    },
    dropdownItem: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "12px 16px",
      textDecoration: "none",
      color: "#475569",
      fontSize: "14px",
      fontWeight: "500",
      border: "none",
      backgroundColor: "transparent",
      width: "100%",
      textAlign: "left",
      cursor: "pointer",
      transition: "background-color 0.15s ease",
    },
    dropdownItemDanger: {
      color: "#dc2626",
    },
    divider: {
      height: "1px",
      backgroundColor: "#e2e8f0",
      margin: 0,
    },
  }

  const [hoveredItem, setHoveredItem] = useState(null)
  const [hoveredSubItem, setHoveredSubItem] = useState(null)
  const [showUserDropdown, setShowUserDropdown] = useState(false)

  return (
    <>
      <style>{`
        @media (max-width: 1024px) {
          /* Mobile sidebar adjustments */
        }

        @media (max-width: 768px) {
          /* Tablet adjustments */
        }

        @media (max-width: 480px) {
          /* Mobile phone adjustments */
        }

        /* Scrollbar styling for sidebar */
        nav::-webkit-scrollbar {
          width: 6px;
        }

        nav::-webkit-scrollbar-track {
          background: transparent;
        }

        nav::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 3px;
        }

        nav::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          style={styles.overlay}
          onClick={onClose}
        />
      )}
      <nav style={styles.sidebar}>
        {/* Brand Section */}
        <div style={styles.brandSection}>
          <a href="/" style={styles.brandLink}>
            <div style={styles.brandIcon}>
              <img src={Logo || "/placeholder.svg"} style={styles.brandIcon} alt="u2lr link manager" />
            </div>
            <div>
              <div style={styles.brandName}>U2lr</div>
              <div style={styles.brandSub}>Link Shortener</div>
            </div>
          </a>
        </div>

        {/* Navigation */}
        <div style={styles.navSection}>
          <ul style={styles.navList}>
            {navItems.map((item) => {
              const active = location.pathname === item.path
              const allowed = hasAccess(item)
              const isHovered = hoveredItem === item.name

              if (item.dropdown) {
                const isOpen = openDropdown === item.name
                return (
                  <li key={item.name}>
                    <div
                      style={{
                        ...styles.navItem,
                        ...(isHovered && !item.highlight ? styles.navItemHover : {}),
                        ...(!allowed ? styles.navItemLocked : {}),
                      }}
                      onClick={() => allowed && toggleDropdown(item.name)}
                      onMouseEnter={() => setHoveredItem(item.name)}
                      onMouseLeave={() => setHoveredItem(null)}
                    >
                      <span style={styles.navIcon}>{item.icon}</span>
                      <span style={{ flex: 1 }}>{item.name}</span>
                      <FaChevronDown
                        style={{
                          ...styles.chevron,
                          ...(isOpen ? styles.chevronOpen : {}),
                        }}
                      />
                    </div>
                    {isOpen && (
                      <ul style={styles.dropdown}>
                        {item.dropdown.map((sub) => {
                          const subActive = location.pathname === sub.path
                          const subHovered = hoveredSubItem === sub.name
                          return (
                            <li key={sub.name}>
                              {sub.action === "createModal" ? (
                                <button
                                  style={{
                                    ...styles.subItem,
                                    ...(subHovered ? { backgroundColor: "#f1f5f9", color: "#3b82f6" } : {}),
                                    border: "none",
                                    width: "100%",
                                    textAlign: "left",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setShowCreateModal(true)}
                                  onMouseEnter={() => setHoveredSubItem(sub.name)}
                                  onMouseLeave={() => setHoveredSubItem(null)}
                                >
                                  {sub.name}
                                </button>
                              ) : (
                                <a
                                  href={sub.path}
                                  style={{
                                    ...styles.subItem,
                                    ...(subActive ? styles.subItemActive : {}),
                                    ...(subHovered && !subActive
                                      ? { backgroundColor: "#f1f5f9", color: "#3b82f6" }
                                      : {}),
                                  }}
                                  onMouseEnter={() => setHoveredSubItem(sub.name)}
                                  onMouseLeave={() => setHoveredSubItem(null)}
                                >
                                  {sub.name}
                                </a>
                              )}
                            </li>
                          )
                        })}
                      </ul>
                    )}
                  </li>
                )
              }

              return (
                <li key={item.path}>
                  {allowed ? (
                    <a
                      href={item.path}
                      style={{
                        ...styles.navItem,
                        ...(active ? styles.navItemActive : {}),
                        ...(item.highlight && !active ? styles.navItemHighlight : {}),
                        ...(isHovered && !active && !item.highlight ? styles.navItemHover : {}),
                      }}
                      onMouseEnter={() => setHoveredItem(item.name)}
                      onMouseLeave={() => setHoveredItem(null)}
                    >
                      <span
                        style={{
                          ...styles.navIcon,
                          color: active ? "#ffffff" : item.highlight ? "#b45309" : "#64748b",
                        }}
                      >
                        {item.icon}
                      </span>
                      <span style={{ flex: 1 }}>{item.name}</span>
                      {item.highlight && <FaCrown style={styles.crownBadge} />}
                    </a>
                  ) : (
                    <div
                      style={{
                        ...styles.navItem,
                        ...styles.navItemLocked,
                      }}
                      title={`Requires ${item.allowedPlans?.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(" or ")} plan`}
                    >
                      <span style={styles.navIcon}>{item.icon}</span>
                      <span style={{ flex: 1 }}>{item.name}</span>
                      <FaCrown style={styles.crownBadge} />
                    </div>
                  )}
                </li>
              )
            })}
          </ul>
        </div>

        {/* User Section */}
        <div style={styles.userSection}>
          <div style={{ position: "relative" }}>
            {showUserDropdown && (
              <div style={styles.dropdownMenu}>
                <a
                  href={user?.isAffiliate ? "/affiliate/dashboard" : "/affiliate/register"}
                  style={styles.dropdownItem}
                  onClick={() => setShowUserDropdown(false)}
                >
                  <FaUserFriends style={{ fontSize: "14px", color: "#64748b" }} />
                  {user?.isAffiliate ? "Partner Dashboard" : "Become a partner"}
                </a>
                <a href="/account/settings" style={styles.dropdownItem} onClick={() => setShowUserDropdown(false)}>
                  <FaCog style={{ fontSize: "14px", color: "#64748b" }} />
                  Settings
                </a>
                <div style={styles.divider} />
                <button
                  style={{ ...styles.dropdownItem, ...styles.dropdownItemDanger }}
                  onClick={() => {
                    setShowUserDropdown(false)
                    logout()
                    setTimeout(()=> {
                      navigate('/')
                    }, 3000);
                  }}
                >
                  <FaSignOutAlt style={{ fontSize: "14px" }} />
                  Logout
                </button>
              </div>
            )}
            <div style={styles.userCard} onClick={() => setShowUserDropdown(!showUserDropdown)}>
  {user?.avatar ? (
    <img
      src={user.avatar || "/placeholder.svg"}
      style={styles.userAvatar}
      alt="User Avatar"
    />
  ) : (
    <div
      style={{
        ...styles.userAvatar,
        backgroundColor: "#3b83f6ca", // circle background color
        color: "#ffffff",           // text color
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        fontSize: "1rem",
        textTransform: "uppercase",
      }}
    >
      {user?.userName?.[0] || "U"} {/* first letter of name or "U" */}
    </div>
  )}

  <div style={{ flex: 1 }}>
    <div style={styles.userName}>{user?.userName || "User"}</div>
    <span style={styles.planBadge}>{user?.plan || "free"}</span>
  </div>

  <FaChevronDown
    style={{
      fontSize: "10px",
      color: "#94a3b8",
      transform: showUserDropdown ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.2s ease",
    }}
  />
</div>

          </div>
        </div>
      </nav>

      <CreateLinkModal
        show={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onCreated={() => {
          setShowCreateModal(false)
        }}
      />
    </>
  )
}